// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import FormController from "./form_controller"

window.Stimulus = Application.start()
Stimulus.register("form", FormController)
